/**
 * 浏览器存储登录信息的键名
 * @type {string}
 */
export const IS_LOGIN_KEY = "GAO_LOGIN";

/**
 * 登录页面
 * @type {string}
 */
export const LOGIN_PATH = "/login";

/**
 * 首页
 * @type {string}
 */
export const INDEX_PATH = "/";

/**
 * 修改用户密码信息页面
 * @type {string}
 */
export const CHANGE_USER_PASSWORD_PATH = "/forget";

/**
 * 用户注册页面
 * @type {string}
 */
export const REGISTER_PATH = "/register";

/**
 * 字符映射表
 * @type {{"math-bold": {"\n": string, "𝟐": string, " ": string, "•": string, "✦": string, "𝙑": string, "0": string, "1": string, "2": string, "3": string, "4": string, "5": string, "6": string, "7": string, "8": string, "9": string, ":": string, A: string, B: string, C: string, D: string, E: string, F: string, G: string, H: string, I: string, J: string, K: string, "𝙥": string, L: string, M: string, N: string, O: string, P: string, Q: string, R: string, "𝙞": string, S: string, T: string, U: string, "𝙣": string, V: string, W: string, "𝙡": string, X: string, Y: string, Z: string, "𝟖": string, "𝟕": string, "𝙚": string, a: string, b: string, c: string, d: string, e: string, f: string, g: string, h: string, i: string, j: string, k: string, l: string, m: string, n: string, o: string, p: string, q: string, r: string, s: string, t: string, u: string, v: string, w: string, x: string, y: string, z: string}, "math-italic": {"\n": string, "𝟐": string, " ": string, "•": string, "✦": string, "𝙑": string, "0": string, "1": string, "2": string, "3": string, "4": string, "5": string, "6": string, "7": string, "8": string, "9": string, ":": string, A: string, B: string, C: string, D: string, E: string, F: string, G: string, H: string, I: string, J: string, K: string, "𝙥": string, L: string, M: string, N: string, O: string, P: string, Q: string, R: string, "𝙞": string, S: string, T: string, U: string, "𝙣": string, V: string, W: string, "𝙡": string, X: string, Y: string, Z: string, "𝟖": string, "𝟕": string, "𝙚": string, a: string, b: string, c: string, d: string, e: string, f: string, g: string, h: string, i: string, j: string, k: string, l: string, m: string, n: string, o: string, p: string, q: string, r: string, s: string, t: string, u: string, v: string, w: string, x: string, y: string, z: string}, circled: {"\n": string, "𝟐": string, " ": string, "•": string, "✦": string, "𝙑": string, "0": string, "1": string, "2": string, "3": string, "4": string, "5": string, "6": string, "7": string, "8": string, "9": string, ":": string, A: string, B: string, C: string, D: string, E: string, F: string, G: string, H: string, I: string, J: string, K: string, "𝙥": string, L: string, M: string, N: string, O: string, P: string, Q: string, R: string, "𝙞": string, S: string, T: string, U: string, "𝙣": string, V: string, W: string, "𝙡": string, X: string, Y: string, Z: string, "𝟖": string, "𝟕": string, "𝙚": string, a: string, b: string, c: string, d: string, e: string, f: string, g: string, h: string, i: string, j: string, k: string, l: string, m: string, n: string, o: string, p: string, q: string, r: string, s: string, t: string, u: string, v: string, w: string, x: string, y: string, z: string}, fullwidth: {"\n": string, "𝟐": string, " ": string, "•": string, "✦": string, "𝙑": string, "0": string, "1": string, "2": string, "3": string, "4": string, "5": string, "6": string, "7": string, "8": string, "9": string, ":": string, A: string, B: string, C: string, D: string, E: string, F: string, G: string, H: string, I: string, J: string, K: string, "𝙥": string, L: string, M: string, N: string, O: string, P: string, Q: string, R: string, "𝙞": string, S: string, T: string, U: string, "𝙣": string, V: string, W: string, "𝙡": string, X: string, Y: string, Z: string, "𝟖": string, "𝟕": string, "𝙚": string, a: string, b: string, c: string, d: string, e: string, f: string, g: string, h: string, i: string, j: string, k: string, l: string, m: string, n: string, o: string, p: string, q: string, r: string, s: string, t: string, u: string, v: string, w: string, x: string, y: string, z: string}}}
 */
export const FONT_MAPS = {
  // 1. 数学加粗
  "math-bold": {
    A: "𝐀",
    B: "𝐁",
    C: "𝐂",
    D: "𝐃",
    E: "𝐄",
    F: "𝐅",
    G: "𝐆",
    H: "𝐇",
    I: "𝐈",
    J: "𝐉",
    K: "𝐊",
    L: "𝐋",
    M: "𝐌",
    N: "𝐍",
    O: "𝐎",
    P: "𝐏",
    Q: "𝐐",
    R: "𝐑",
    S: "𝐒",
    T: "𝐓",
    U: "𝐔",
    V: "𝐕",
    W: "𝐖",
    X: "𝐗",
    Y: "𝐘",
    Z: "𝐙",
    a: "𝐚",
    b: "𝐛",
    c: "𝐜",
    d: "𝐝",
    e: "𝐞",
    f: "𝐟",
    g: "𝐠",
    h: "𝐡",
    i: "𝐢",
    j: "𝐣",
    k: "𝐤",
    l: "𝐥",
    m: "𝐦",
    n: "𝐧",
    o: "𝐨",
    p: "𝐩",
    q: "𝐪",
    r: "𝐫",
    s: "𝐬",
    t: "𝐭",
    u: "𝐮",
    v: "𝐯",
    w: "𝐰",
    x: "𝐱",
    y: "𝐲",
    z: "𝐳",
    1: "𝟏",
    2: "𝟐",
    3: "𝟑",
    4: "𝟒",
    5: "𝟓",
    6: "𝟔",
    7: "𝟕",
    8: "𝟖",
    9: "𝟗",
    0: "𝟎",
    // 特殊字符（已去除重复）
    "𝙑": "𝙑",
    "𝙞": "𝙞",
    "𝙥": "𝙥",
    "𝙡": "𝙡",
    "𝙣": "𝙣",
    "𝙚": "𝙚",
    "𝟐": "𝟐",
    "𝟕": "𝟕",
    "𝟖": "𝟖",
    "✦": "✦",
    "•": "•",
    ":": ":",
    " ": " ",
    "\n": "\n",
  },
  // 2. 数学斜体
  "math-italic": {
    A: "𝐴",
    B: "𝐵",
    C: "𝐶",
    D: "𝐷",
    E: "𝐸",
    F: "𝐹",
    G: "𝐺",
    H: "𝐻",
    I: "𝐼",
    J: "𝐽",
    K: "𝐾",
    L: "𝐿",
    M: "𝑀",
    N: "𝑁",
    O: "𝑂",
    P: "𝑃",
    Q: "𝑄",
    R: "𝑅",
    S: "𝑆",
    T: "𝑇",
    U: "𝑈",
    V: "𝑉",
    W: "𝑊",
    X: "𝑋",
    Y: "𝑌",
    Z: "𝑍",
    a: "𝑎",
    b: "𝑏",
    c: "𝑐",
    d: "𝑑",
    e: "𝑒",
    f: "𝑓",
    g: "𝑔",
    h: "ℎ",
    i: "𝑖",
    j: "𝑗",
    k: "𝑘",
    l: "𝑙",
    m: "𝑚",
    n: "𝑛",
    o: "𝑜",
    p: "𝑝",
    q: "𝑞",
    r: "𝑟",
    s: "𝑠",
    t: "𝑡",
    u: "𝑢",
    v: "𝑣",
    w: "𝑤",
    x: "𝑥",
    y: "𝑦",
    z: "𝑧",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    0: "0",
    // 特殊字符（已去除重复）
    "𝙑": "𝙑",
    "𝙞": "𝙞",
    "𝙥": "𝙥",
    "𝙡": "𝙡",
    "𝙣": "𝙣",
    "𝙚": "𝙚",
    "𝟐": "𝟐",
    "𝟕": "𝟕",
    "𝟖": "𝟖",
    "✦": "✦",
    "•": "•",
    ":": ":",
    " ": " ",
    "\n": "\n",
  },
  // 3. 圆圈体
  circled: {
    A: "Ⓐ",
    B: "Ⓑ",
    C: "Ⓒ",
    D: "Ⓓ",
    E: "Ⓔ",
    F: "Ⓕ",
    G: "Ⓖ",
    H: "Ⓗ",
    I: "Ⓘ",
    J: "Ⓙ",
    K: "Ⓚ",
    L: "Ⓛ",
    M: "Ⓜ",
    N: "Ⓝ",
    O: "Ⓞ",
    P: "Ⓟ",
    Q: "Ⓠ",
    R: "Ⓡ",
    S: "Ⓢ",
    T: "Ⓣ",
    U: "Ⓤ",
    V: "Ⓥ",
    W: "Ⓦ",
    X: "Ⓧ",
    Y: "Ⓨ",
    Z: "Ⓩ",
    a: "ⓐ",
    b: "ⓑ",
    c: "ⓒ",
    d: "ⓓ",
    e: "ⓔ",
    f: "ⓕ",
    g: "ⓖ",
    h: "ⓗ",
    i: "ⓘ",
    j: "ⓙ",
    k: "ⓚ",
    l: "ⓛ",
    m: "ⓜ",
    n: "ⓝ",
    o: "ⓞ",
    p: "ⓟ",
    q: "ⓠ",
    r: "ⓡ",
    s: "ⓢ",
    t: "ⓣ",
    u: "ⓤ",
    v: "ⓥ",
    w: "ⓦ",
    x: "ⓧ",
    y: "ⓨ",
    z: "ⓩ",
    1: "①",
    2: "②",
    3: "③",
    4: "④",
    5: "⑤",
    6: "⑥",
    7: "⑦",
    8: "⑧",
    9: "⑨",
    0: "⓪",
    // 特殊字符（已去除重复）
    "𝙑": "𝙑",
    "𝙞": "𝙞",
    "𝙥": "𝙥",
    "𝙡": "𝙡",
    "𝙣": "𝙣",
    "𝙚": "𝙚",
    "𝟐": "𝟐",
    "𝟕": "𝟕",
    "𝟖": "𝟖",
    "✦": "✦",
    "•": "•",
    ":": ":",
    " ": " ",
    "\n": "\n",
  },
  // 4. 全角体
  fullwidth: {
    A: "Ａ",
    B: "Ｂ",
    C: "Ｃ",
    D: "Ｄ",
    E: "Ｅ",
    F: "Ｆ",
    G: "Ｇ",
    H: "Ｈ",
    I: "Ｉ",
    J: "Ｊ",
    K: "Ｋ",
    L: "Ｌ",
    M: "Ｍ",
    N: "Ｎ",
    O: "Ｏ",
    P: "Ｐ",
    Q: "Ｑ",
    R: "Ｒ",
    S: "Ｓ",
    T: "Ｔ",
    U: "Ｕ",
    V: "Ｖ",
    W: "Ｗ",
    X: "Ｘ",
    Y: "Ｙ",
    Z: "Ｚ",
    a: "ａ",
    b: "ｂ",
    c: "ｃ",
    d: "ｄ",
    e: "ｅ",
    f: "ｆ",
    g: "ｇ",
    h: "ｈ",
    i: "ｉ",
    j: "ｊ",
    k: "ｋ",
    l: "ｌ",
    m: "ｍ",
    n: "ｎ",
    o: "ｏ",
    p: "ｐ",
    q: "ｑ",
    r: "ｒ",
    s: "ｓ",
    t: "ｔ",
    u: "ｕ",
    v: "ｖ",
    w: "ｗ",
    x: "ｘ",
    y: "ｙ",
    z: "ｚ",
    1: "１",
    2: "２",
    3: "３",
    4: "４",
    5: "５",
    6: "６",
    7: "７",
    8: "８",
    9: "９",
    0: "０",
    // 特殊字符（已去除重复）
    "𝙑": "𝙑",
    "𝙞": "𝙞",
    "𝙥": "𝙥",
    "𝙡": "𝙡",
    "𝙣": "𝙣",
    "𝙚": "𝙚",
    "𝟐": "𝟐",
    "𝟕": "𝟕",
    "𝟖": "𝟖",
    "✦": "✦",
    "•": "•",
    ":": ":",
    " ": " ",
    "\n": "\n",
  },
};

/**
 * 高德地图应用创建地图key值
 * @type {string}
 */
export const GAO_DE_LOAD_KEY = "5861ad5da8cb8ae2c2c996eb415787b4";

/**
 * 高德地图应用插件key值
 * @type {string}
 */
export const GAO_DE_FUNC_KEY = "c00f6e11ea415e453e24faa1978641a1";

/**
 * 选择任务表格的最大数值
 * @type {number}
 */
export const MAX_SCHEDULE_LIMIT = 10;
